export enum QueryKey {
  CAMPAIGN_DATA = 'campaign_data',
  PLATFORM_INTEGRATIONS = 'platform_integrations',
  BUILDER_TABLE_VIEW = 'builder_table_view',
  BUILDER_SCHEMA = 'builder_schema',
  BUYING_PLAN_LIST = 'buying_plan_list',
  BUYING_PLAN_META = 'buying_plan_meta',
  BUYING_PLAN_INFO = 'buying_plan_info',
  CHECK_HISTORICAL_DATA = 'check_historical_data',
  CHECK_AVAILABLE_METRICS = 'check_available_metrics',
  GET_PREDICTIVE_PLANNING_ROWS = 'get_predictive_planning_rows',
  GET_VERSION_LIST = 'get_version_list',
  CHANNEL_MIX_VERSION = 'channel_mix_version',
  GET_VERSION = 'get_version',
  GET_VERSION_LIST_FOR_TABLE_VIEW = 'get_version_list_for_table_view',
}
